import React, { useState } from "react";
import "../styles/login.css";
import GoogleLoginButton from "../components/GoogleLoginButton/GoogleLoginButton";
import TokenBox from "../components/TokenBox/TokenBox";
import JwtDisplayBox from "../components/JwtDisplayBox/JwtDisplayBox";
import { googleLogin, verifyJwt } from "../api/authApi";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";


function LoginPage() {
  const [backendJwt, setBackendJwt] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);


  const handleGoogleSuccess = async (googleIdToken) => {
    try {
      const res = await googleLogin(googleIdToken);
      setBackendJwt(res.data.jwt);
    } catch {
      alert("Google login failed");
    }
  };

  const handleTokenLogin = async (jwtToken) => {
    try {
      const res = await verifyJwt(jwtToken);
      const userData = res.data;
      console.log("User data from JWT verification:", userData);
    // Login now stores both JWT + user info
      login(jwtToken, userData);
      navigate("/dashboard");

    } catch {
      alert("Invalid JWT");
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Login</h2>

      <GoogleLoginButton onGoogleSuccess={handleGoogleSuccess} />

      {backendJwt && <JwtDisplayBox jwt={backendJwt} />}

      <TokenBox onSubmit={handleTokenLogin} />
    </div>
  );
}

export default LoginPage;
